<template>
  <div class="company-applyment-module" v-loading="loading">
    <!-- 状态 -->
    <el-affix
      :class="{ 'applyment-page-header-top': affixed, 'applyment-page-header-shrink': sidebarFold, 'applyment-page-header-unfold': !sidebarFold }"
      @change="handleAffixChange"
      :offset="80"
    >
      <el-card>
        <div class="applyment-page-header">
          <div class="status">
            {{ refundStatusFormat(detail.status) }}
          </div>
          <div class="page-header-heading-right">
            <div class="ml10 hg36 opts">
              <!-- 确认退款 - 财务 -->
              <el-button
                type="primary"
                size="medium"
                @click="handleConfirmRefund"
                v-if="isAuth('finance:financial') && ['REFUNDING', 'REFUND_INFO_UPDATED', 'REFUND_PENDING'].includes(detail?.status)"
              >
                Confirm Refund
              </el-button>
            </div>
          </div>
        </div>
      </el-card>
    </el-affix>

    <!-- 退款信息 - 普通订单、补款单 -->
    <div class="step mt20" v-if="detail">
      <el-card shadow="hover">
        <refund-info :detail="detail" />
      </el-card>
    </div>

    <!-- 关联的订单列表 -->
    <div class="step mt20" v-if="detail?.orderList?.length > 0">
      <el-card shadow="hover">
        <linked-order-list :detail="detail" />
      </el-card>
    </div>

    <!-- 确认退款 - 弹窗 -->
    <confirm-refund ref="confirmRefundModal" :detail="detail"></confirm-refund>
  </div>
</template>

<script>
import { mapActions, mapMutations, mapState } from "vuex";
import LinkedOrderList from "../modules/linkedOrderList";
import RefundInfo from "../modules/refundInfo";
import ConfirmRefund from "./modal/ConfirmRefund.vue";
import formatterMixin from "@/mixins/formatterMixin";
export default {
  mixins: [formatterMixin],
  components: {
    LinkedOrderList,
    RefundInfo,
    ConfirmRefund,
  },
  data() {
    return {
      affixed: false,
      loading: true,
    };
  },
  computed: {
    ...mapState("finance", ["detail"]),
    sidebarFold: {
      get() {
        return this.$store.state.common.sidebarFold;
      },
    },
  },
  methods: {
    ...mapActions("finance", ["initRefundOrder"]),
    ...mapMutations("finance", ["RESET_DETAIL"]),
    handleAffixChange(fixed) {
      this.affixed = fixed;
    },
    // 详情
    async getDetail() {
      this.loading = true;
      try {
        await this.initRefundOrder(this.id);
      } catch (err) {
        console.error(err);
      }
      this.loading = false;
    },
    // 确认退款 - 财务
    handleConfirmRefund() {
      this.$refs.confirmRefundModal.init();
    },
  },
  activated() {
    // 先重置退款单详情
    this.RESET_DETAIL();
    // 请求退款单详情
    this.id = this.$route.params.id;
    this.getDetail();
  },
};
</script>

<style lang="scss">
@import "~@/assets/scss/variables.scss";

.company-applyment-module {
  .applyment-page-header {
    background-color: #fff;
    // padding: 10px 20px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .page-header-heading-left {
      display: none;
    }

    .page-header-heading-content {
      width: 620px;
    }

    .page-header-heading-right {
      .opts {
        display: inline-block;
      }
    }
    .status {
      display: inline-block;
      font-size: 20px;
      font-weight: bold;
      margin-right: 20px;
      color: #12a3ff;
    }
    .status::before {
      display: inline-block;
      content: "";
      background: #12a3ff;
      width: 6px;
      height: 6px;
      border-radius: 6px;
      vertical-align: middle;
      margin-right: 4px;
      margin-top: -4px;
    }
  }
  .applyment-page-header-top {
    .affix {
      z-index: 1030 !important;
    }
    .page-header-heading-left {
      display: inline-block;
    }
    .page-header-heading-content {
      display: none;
    }
    .status-label {
      display: none;
    }
  }

  .applyment-page-header-shrink {
    .affix {
      left: $sidebar-width !important;
      width: calc(100% - #{$sidebar-width} - 18px) !important;
    }
  }

  .applyment-page-header-unfold {
    .affix {
      left: $sidebar-full-width !important;
      width: calc(100% - #{$sidebar-full-width} - 18px) !important;
    }
  }

  .steps-bar-wrapper {
    position: fixed;
    right: 6px;
    top: 38vh;
    z-index: 1000;
  }

  .desp {
    color: rgb(53, 55, 68);

    .desp-header {
      font-size: 18px;
      padding: 10px 5px 10px;
      border-bottom: 1px solid #ebeef0;
      margin-bottom: 15px;
      color: #011a45;
      display: flex;
      justify-content: space-between;
      align-items: center;
      font-weight: 700;
    }

    .desp-items-group {
      & + .desp-items-group {
        margin-top: 24px;
      }
    }

    .desp-items-group-title {
      padding: 1px 14px;
      font-size: 16px;
      margin-bottom: 10px;
      width: fit-content;
      border-left: 3px solid #eee;
      color: #011a45;
      font-weight: bold;
    }

    .desp-items-group-title-icon {
      padding: 1px 14px;
      font-size: 16px;
      margin-bottom: 10px;
      width: fit-content;
      color: #011a45;
      font-weight: bold;
    }

    .desp-items-group-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 5px 10px;
      color: #0060ff;
      // border-left: 3px solid #eee;
      background: #eceff9;
      margin-bottom: 15px;

      .title {
        font-weight: bold;
        font-size: 16px;
      }
    }

    .desp-item {
      overflow: hidden;
    }

    .desp-item-label {
      width: 166px;
      text-align: right;
      vertical-align: middle;
      float: left;
      font-size: 14px;
      color: #667288;
      line-height: 40px;
      padding: 0 12px 0 0;
      box-sizing: border-box;
    }

    .desp-item-label:after {
      content: ":";
      position: relative;
      top: -0.5px;
      margin: 0 8px 0 2px;
    }

    .desp-item-content {
      margin-left: 136px;
      line-height: 40px;
      position: relative;
      font-size: 14px;
      color: #011a45;
    }

    .desp-item-self {
      width: 100%;
      vertical-align: middle;
      float: left;
      font-size: 14px;
      color: #606266;
      line-height: 40px;
      padding: 0 12px 0;
      box-sizing: border-box;
    }

    .desp-item-form {
      width: 100%;
      vertical-align: middle;
      font-size: 14px;
      color: #606266;
      line-height: 40px;
      padding: 0;
      box-sizing: border-box;
    }
  }
}
</style>
